import { combineReducers } from 'redux';

import  authReducer  from './../reducers/auth-reducer'
import  userReducer  from './../reducers/user-reducer'
import  agentsReducer  from './../reducers/agents-reducer'
import configurationReducer from './../reducers/configuration-reducer'
import paymentMethodReducer from './../reducers/payment-method-reducer'

const rootReducer = combineReducers({
    authReducer,
    userReducer,
    agentsReducer,
    configurationReducer,
    paymentMethodReducer
});

export default rootReducer;